module.exports = __webpack_public_path__ + "img/teddy-bear.3578043d.svg";